import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, SvgIcon } from '@mui/material';

import { spaces } from '../../assets/styles/themes/tokens';
import useScreenSize from '../../utils/useScreenSize';
import getMuiIcon from '../../utils/getMuiIcon';

interface FollowedCollectionsHeaderButtonProps {
  onClickButton: () => void;
}

const FollowedCollectionsHeaderButton = ({ onClickButton }: FollowedCollectionsHeaderButtonProps) => {
  const { t } = useTranslation();
  const { isXsScreen } = useScreenSize();

  return (
    <Button
      data-testid='go-to-curated-collections-button'
      variant='outlined'
      color='primary'
      size={isXsScreen ? 'small' : 'large'}
      sx={{ paddingY: spaces.xs, paddingX: spaces.lg }}
      onClick={onClickButton}
      endIcon={
        <SvgIcon component={getMuiIcon('arrowUpRightLong')} viewBox='0 0 20 20'/>
      }
    >
      {t('Curated Collections')}
    </Button>
  );
};

export default FollowedCollectionsHeaderButton;
